import React from 'react'
import { isMobileOnly, isTablet } from 'react-device-detect'
import PropTypes from 'prop-types'

import { Dots, FlyingCube, Heading } from 'Components/Blocks/_Legacy'
import { ProvideSubRow } from 'Components/Sections/_Legacy/Blockchain/Dapps/styles'
import { Border, Icon, Link, Motion, Text, Wrapper } from 'Components/UI'
import { Button } from 'Components/UI/_Legacy'

import find from 'lodash/find'

import { programmingGlyph } from 'Assets/_Legacy/BlockchainPage/icons'
import arrowRightShortGlyph from 'Assets/_Legacy/Svg/arrow-right-short.svg'

import {
  NFT_DEVELOPMENT_GLYPHS,
  NFT_PROVIDE_CARDS_DATA,
} from 'Constants/Blockchain'
import { PROJECT, WORK } from 'Constants/Paths'

import { useAppContext } from 'Services/AppContext'

import {
  ButtonWrapper,
  Container,
  Content,
  CropContainer,
  DevelopmentCard,
  DevelopmentHolder,
  DevelopmentImageHolder,
  DevelopmentTextHolder,
  DotsWrapper,
  ProvideCard,
  ProvideHolder,
  ProvideIconHolder,
  ProvideSubHolder,
  ProvideTextHolder,
} from './styles'

function Nft({ data }) {
  const { openSupportWidget } = useAppContext()

  const projects = data?.projectsData?.projectsData || null
  return (
    <>
      <Border almond topRight />
      <Container>
        <FlyingCube
          left={[0, 0, -50, -50, -75, -75, -100]}
          rotateAngle={isTablet ? 39 : 69}
          size={[0, 0, 140, 140, 200, 200, 277]}
          top={[0, 0, -145, -145, -130, -130, -155]}
        />

        <CropContainer>
          <FlyingCube
            left={0}
            rotateAngle={39}
            size={[0, 0, 90, 90, 140, 140, 180]}
            top={0}
          />
        </CropContainer>

        <Wrapper wayPointTop>
          <Content>
            <Motion>
              <Heading
                horizontalAlign="center"
                maxWidth={700}
                mb={[56, 56, 64, 64, 88]}
                mx="auto"
                subTitleText={data?.nftHeader?.subtitleText}
                tagGlyph={programmingGlyph}
                tagText={data?.nftHeader?.overheadText}
                tagTextAs="h4"
                titleText={{
                  first: {
                    text: data?.nftHeader?.titleTextFirst,
                    bold: data?.nftHeader?.firstBold,
                  },
                  second: {
                    text: data?.nftHeader?.titleTextSecond,
                    bold: data?.nftHeader?.secondBold,
                  },
                  third: {
                    text: data?.nftHeader?.titleTextThird,
                    bold: data?.nftHeader?.thirdBold,
                  },
                }}
              />

              <DevelopmentHolder mb={[48, 48, 64, 64, 88]}>
                {data?.nftDevelopmentBlocks.map((item, index) => {
                  const even = index % 2
                  return (
                    <DevelopmentCard key={item.id}>
                      <DevelopmentTextHolder
                        order={[1, 1, even ? 1 : 0]}
                        pl={[0, 0, even ? 24 : 0, even ? 24 : 0, even ? 32 : 0]}
                        pr={[0, 0, even ? 0 : 24, even ? 0 : 24, even ? 0 : 32]}
                      >
                        <Text
                          as="h3"
                          bold
                          fontSize={[20, 20, 40]}
                          mb={[16, 16, 24]}
                        >
                          {item.title}
                        </Text>

                        <Text fontSize={[14, 14, 16]} light>
                          {item.description}
                        </Text>
                      </DevelopmentTextHolder>

                      <DevelopmentImageHolder mb={[32, 32, 0]}>
                        <Icon
                          glyph={NFT_DEVELOPMENT_GLYPHS[index]}
                          size="100%"
                        />
                      </DevelopmentImageHolder>
                    </DevelopmentCard>
                  )
                })}
              </DevelopmentHolder>

              <Heading
                fontSizes={{ title: [20, 20, 40], sub: [14, 16] }}
                horizontalAlign={isMobileOnly ? 'left' : 'center'}
                mb={[72, 72, 88, 88, 120]}
                mx="auto"
                subTitleText={data?.nftHeaderSlave?.subtitleText}
                titleText={{
                  first: {
                    text: data?.nftHeaderSlave?.titleTextFirst,
                    bold: data?.nftHeaderSlave?.firstBold,
                  },
                  second: {
                    text: data?.nftHeaderSlave?.titleTextSecond,
                    bold: data?.nftHeaderSlave?.secondBold,
                  },
                  third: {
                    text: data?.nftHeaderSlave?.titleTextThird,
                    bold: data?.nftHeaderSlave?.thirdBold,
                  },
                }}
              />

              <ProvideHolder mb={[32, 32, 32, 32, 40]}>
                {data?.nftProvideBlocks.map((item, index) => (
                  <ProvideCard key={item.id}>
                    <ProvideIconHolder>
                      <Icon
                        glyph={NFT_PROVIDE_CARDS_DATA[index].glyph}
                        size={[36, 36, 46]}
                      />
                    </ProvideIconHolder>
                    <ProvideTextHolder mb={[24, 24, 20, 20, 32]}>
                      <Text
                        as="h3"
                        bold
                        fontSize={[16, 16, 20]}
                        mb={[8, 8, 8, 8, 16]}
                      >
                        {item.title}
                      </Text>
                      <Text fontSize={[14, 14, 14, 14, 16]} light>
                        {item.description}
                      </Text>
                    </ProvideTextHolder>

                    <ProvideSubHolder>
                      {NFT_PROVIDE_CARDS_DATA[index].sub.map(entity => {
                        const project = find(projects, ['id', entity.projectId])
                        const link = project
                          ? PROJECT(project?.slug ?? WORK)
                          : '#void'
                        return (
                          entity.projectId && (
                            <Link
                              href={link}
                              key={entity.subText}
                              mr={[24, 24, 24, 16, 32]}
                            >
                              <ProvideSubRow pointerCursor={project}>
                                <Icon
                                  mr={12}
                                  size={[30, 30, 30, 25, 30]}
                                  src={entity.subImage}
                                />

                                <Text fontSize={[16, 16, 16, 14, 16]} light>
                                  {entity.subText}
                                </Text>
                              </ProvideSubRow>
                            </Link>
                          )
                        )
                      })}
                    </ProvideSubHolder>
                  </ProvideCard>
                ))}

                <DotsWrapper>
                  <Dots columns={isTablet ? 12 : 18} primary rows={18} />
                </DotsWrapper>
              </ProvideHolder>

              <ButtonWrapper>
                <Button blueprint width={250} onClick={openSupportWidget}>
                  Discuss a project
                  <Icon glyph={arrowRightShortGlyph} ml={12} size={10} />
                </Button>
              </ButtonWrapper>
            </Motion>
          </Content>
        </Wrapper>
      </Container>
      <Border almond bottomLeft />
    </>
  )
}

Nft.defaultProps = {
  data: {},
}

Nft.propTypes = {
  data: PropTypes.object,
}

export default Nft
